export default "__VITE_ASSET__DR2iELFf__"